import { InputRule, inputRules } from 'prosemirror-inputrules';

const LOWERCASE_FIRST_LETTER = /^\p{Ll}$/u;

// Fallback for callers that don't know about signatures: whatever the rule is
// about to leave behind must be blank. Editor.vue passes a signature-aware
// predicate instead, since a new draft may already hold the agent's signature.
const isRemainderBlank = (state, from) =>
  state.doc.textBetween(from, state.doc.content.size, '\n', '\n').trim() === '';

export function capitalizeFirstLetterInputRule(
  isDraftEmpty = isRemainderBlank
) {
  return new InputRule(LOWERCASE_FIRST_LETTER, (state, match, start, end) => {
    if (start !== 1) {
      return null;
    }
    // `start === 1` alone only says the caret sits at the very beginning, which
    // is also true when the agent moves the caret back to the start of a draft
    // they already wrote — an edit, not a new draft. Everything the rule leaves
    // untouched lives between `end` and the end of the document, so that is
    // what decides. Passing positions (rather than extracted text) lets the
    // caller read the document in whatever format its signature check needs.
    if (!isDraftEmpty(state, end)) {
      return null;
    }
    return state.tr.insertText(match[0].toUpperCase(), start, end);
  });
}

export function capitalizeFirstLetterPlugin(isDraftEmpty) {
  return inputRules({ rules: [capitalizeFirstLetterInputRule(isDraftEmpty)] });
}
